import React, { useState } from 'react';
import { publicService } from '../../services/public.service';
import { showAppAlert } from '../../utils/appAlert';

const CallToAction = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [contactStatus, setContactStatus] = useState('idle');
  const [contactForm, setContactForm] = useState({
    fullName: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    try {
      await publicService.subscribeToNewsletter(email);
      setStatus('success');
      setEmail('');
      showAppAlert({ type: 'success', title: 'Subscribed', message: 'You are now subscribed to Go Rides updates.' });
    } catch (error) {
      console.error('Newsletter error:', error);
      setStatus('error');
      showAppAlert({ type: 'error', title: 'Subscription failed', message: 'We could not subscribe your email right now.' });
    }
  };

  const handleContactChange = (field) => (event) => {
    setContactForm((current) => ({
      ...current,
      [field]: event.target.value
    }));
  };

  const handleContactSubmit = async (event) => {
    event.preventDefault();
    setContactStatus('loading');

    try {
      await publicService.submitContactMessage(contactForm);
      setContactStatus('success');
      setContactForm({
        fullName: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
      showAppAlert({ type: 'success', title: 'Message sent', message: 'Our team has received your message and will get back to you soon.' });
    } catch (error) {
      console.error('Contact us error:', error);
      setContactStatus('error');
      showAppAlert({ type: 'error', title: 'Message failed', message: 'We could not send your message. Please try again.' });
    }
  };

  return (
    <section className="bg-brand-black py-7 text-white">
      <div className="max-w-7xl mx-auto px-4 grid lg:grid-cols-[0.9fr_1.1fr] gap-5">
        <div className="bg-white/5 border border-white/10 rounded-[28px] p-5">
          <p className="text-[11px] uppercase tracking-[0.3em] text-gray-400 mb-3">Stay Updated</p>
          <h2 className="text-2xl font-bold mb-3">Ready to Hit the Road?</h2>
          <p className="text-gray-300 mb-3 leading-7">
            Subscribe for fresh fleet drops, premium offers, and rental updates from Go Rides.
          </p>

          <form className="space-y-4" onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 rounded-2xl text-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-400"
              required
              disabled={status === 'loading'}
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="w-full bg-brand-orange-500 text-white font-bold px-5 py-3 rounded-2xl hover:bg-brand-orange-600 transition-colors disabled:opacity-50"
            >
              {status === 'loading' ? 'Subscribing...' : 'Subscribe'}
            </button>
          </form>
        </div>

        <div className="bg-white rounded-[28px] text-gray-900 p-5 shadow-2xl">
          <p className="text-[11px] uppercase tracking-[0.3em] text-gray-400 mb-3">Contact Us</p>
          <h3 className="text-2xl font-bold mb-3">Need help finding the right ride?</h3>
          <p className="text-gray-500 mb-3">
            Send us your travel plan, support request, or preferred vehicle style and our team will get back to you.
          </p>

          <details><summary className="cursor-pointer text-sm font-semibold py-3">Send us a message</summary><form className="mt-3 grid md:grid-cols-2 gap-4" onSubmit={handleContactSubmit}>
            <input
              type="text"
              value={contactForm.fullName}
              onChange={handleContactChange('fullName')}
              placeholder="Full name"
              className="px-5 py-4 rounded-2xl border border-gray-200 outline-none focus:ring-2 focus:ring-[#111111]"
              required
            />
            <input
              type="email"
              value={contactForm.email}
              onChange={handleContactChange('email')}
              placeholder="Email address"
              className="px-5 py-4 rounded-2xl border border-gray-200 outline-none focus:ring-2 focus:ring-[#111111]"
              required
            />
            <input
              type="text"
              value={contactForm.phone}
              onChange={handleContactChange('phone')}
              placeholder="Phone number"
              className="px-5 py-4 rounded-2xl border border-gray-200 outline-none focus:ring-2 focus:ring-[#111111]"
            />
            <input
              type="text"
              value={contactForm.subject}
              onChange={handleContactChange('subject')}
              placeholder="Subject"
              className="px-5 py-4 rounded-2xl border border-gray-200 outline-none focus:ring-2 focus:ring-[#111111]"
              required
            />
            <textarea
              value={contactForm.message}
              onChange={handleContactChange('message')}
              placeholder="Tell us how we can help"
              rows="3"
              className="md:col-span-2 px-5 py-4 rounded-2xl border border-gray-200 outline-none focus:ring-2 focus:ring-[#111111] resize-none"
              required
            />
            <button
              type="submit"
              disabled={contactStatus === 'loading'}
              className="md:col-span-2 bg-brand-black text-white font-bold px-5 py-3 rounded-2xl hover:bg-gray-800 transition-colors disabled:opacity-50"
            >
              {contactStatus === 'loading' ? 'Sending...' : 'Send Message'}
            </button>
          </form></details>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
